import {
  useEffect,
  useState
} from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import { Capacitor } from '@capacitor/core'
import { PushNotifications } from '@capacitor/push-notifications'
import {
  setPosts,
  getComments,
  getPosts,
  setOpenPopupBlogs,
  setBlogParent,
  usersSelectors,
  saveFcmToken,
  setUserSectionPage,
  setOpenPopupEvents,
  setIsBlogFormOpen,
  setOpenBlogForm,
  setChatSectionPage,
  setNotificationSectionPage,
  setBlogRepostData,
  handleOpenModal,
  getNotificationMessage,
  setEventComments,
  setEventCommentTree,
  getEventData,
  setGetProfileItemStatus,
  setOpenFriendRequest,
  setOpenNotifRequest
} from 'store'
import { openConnectedProfileChat } from 'store/chat/slice'
import {
  MODAL_SECTION,
  REJECTED,
  SUCCEEDED
} from 'utils/constants'
import { useGoToProfileMarker } from 'hooks/useGoToProfileMarker'

export const useFCM = ([
  signInStatus,
  isAuth
]) => {
  const dispatch = useDispatch()

  const goToProfileMarker = useGoToProfileMarker()
  const [pushNotifAction, setPushNotifAction] = useState([])

  const {
    activeProfile,
    userProfile
  } = useSelector(usersSelectors)

  const clearUI = () => {
    dispatch(setUserSectionPage('clear'))
    dispatch(setIsBlogFormOpen(false))
    dispatch(setOpenBlogForm(false))
    document.querySelector('#custom-popup-overlay')?.click()
    document.querySelector('#custom-popup-overlay-event')?.click()
    dispatch(setOpenPopupBlogs(false))
    dispatch(setChatSectionPage('clear'))
    dispatch(setOpenPopupEvents(false))
    dispatch(setNotificationSectionPage('clear'))
    dispatch(setBlogRepostData([]))
    // This is for map filter to move
    dispatch(handleOpenModal({ isOpen: false, section: MODAL_SECTION?.RightSection }))
    dispatch(setBlogParent([]))
    dispatch(setPosts([]))
  }

  const initializeFCM = async () => {
    if (Capacitor.isNativePlatform()) {
      await PushNotifications.removeAllListeners()

      let permStatus = await PushNotifications.checkPermissions()
      if (permStatus.receive === 'prompt') {
        permStatus = await PushNotifications.requestPermissions()
      }

      if (permStatus.receive !== 'granted') {
        throw new Error('Permission not granted')
      }

      await PushNotifications.register()

      PushNotifications.addListener('registration', (token) => dispatch(saveFcmToken(token.value)))

      PushNotifications.addListener('registrationError', (err) => console.error(err))

      PushNotifications.addListener(
        'pushNotificationReceived',
        (notification) => {
          console.log('Notification received:', notification)
        }
      )

      PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
        const { data } = action.notification
        setPushNotifAction(data)
      })
    }
  }

  useEffect(() => {
    if (
      pushNotifAction?.type === 'profile'
      && userProfile?.length
    ) {
      clearUI()
      const actionData = pushNotifAction
      setPushNotifAction([])

      goToProfileMarker(
        actionData?.id,
        JSON.parse(actionData?.coordinates)
      )
    }
  }, [userProfile, pushNotifAction])

  useEffect(() => {
    if (
      pushNotifAction?.type === 'post'
      && activeProfile?.id
    ) {
      clearUI()
      const actionData = pushNotifAction
      setPushNotifAction([])

      dispatch(getPosts({
        type: 'single',
        postId: actionData?.id,
        id: activeProfile?.id
      }))
      dispatch(setOpenPopupBlogs(true))
    }
  }, [activeProfile?.id, pushNotifAction])

  useEffect(() => {
    if (
      pushNotifAction?.type === 'comment'
      && activeProfile?.id
    ) {
      const run = async () => {
        clearUI()
        const actionData = pushNotifAction
        setPushNotifAction([])

        dispatch(setOpenPopupBlogs(true))
        const result = await dispatch(getPosts({
          type: 'single',
          postId: actionData?.post_id,
          id: activeProfile?.id
        }))
        const postResults = result?.payload?.posts

        if (postResults?.length) {
          const path = JSON.parse(actionData?.path)

          dispatch(setBlogParent([
            postResults?.at(0),
            ...path
          ]))

          dispatch(getComments({
            type: actionData?.parent_type,
            forceGet: actionData?.id,
            ...(
              actionData?.parent_type === 'post'
                ? { post_id: actionData?.post_id }
                : { comment_id: path?.at(-1)?.comment_id }
            )
          }))
        } else {
          dispatch(
            getNotificationMessage({
              type: REJECTED,
              message: 'This article might be deleted, not existing, or unavailable',
              isEditProfile: false
            })
          )
        }
      }

      run()
    } else if (
      pushNotifAction?.type === 'event'
      && activeProfile?.id
    ) {
      clearUI()
      const actionData = pushNotifAction
      setPushNotifAction([])

      dispatch(setEventComments([]))
      dispatch(setEventCommentTree([]))
      dispatch(getEventData(actionData?.id))
      dispatch(setOpenPopupEvents(true))
    } else if (
      pushNotifAction?.type === 'connReq'
      && activeProfile?.id
    ) {
      clearUI()
      const actionData = pushNotifAction
      setPushNotifAction([])

      dispatch(setGetProfileItemStatus(0))
      dispatch(setOpenFriendRequest(actionData?.id))
      setTimeout(() => document.querySelector('#open-notif-panel').click(), 800)
    } else if (
      pushNotifAction?.type === 'notif'
      && activeProfile?.id
    ) {
      clearUI()
      const actionData = pushNotifAction
      setPushNotifAction([])

      dispatch(setGetProfileItemStatus(0))
      dispatch(setOpenNotifRequest(actionData?.id))
      setTimeout(() => document.querySelector('#open-notif-panel').click(), 800)
    } else if (
      pushNotifAction?.type === 'chat'
      && activeProfile?.id
    ) {
      clearUI()
      const actionData = pushNotifAction
      setPushNotifAction([])

      setTimeout(() => {
        dispatch(setChatSectionPage('chat-main'))
        dispatch(openConnectedProfileChat({ id: actionData?.id }))
      }, 900)
    }
  }, [activeProfile?.id, pushNotifAction])

  useEffect(() => {
    if (
      signInStatus === SUCCEEDED
      || isAuth()
    ) {
      initializeFCM()
    }
  }, [isAuth, signInStatus, activeProfile?.id])

  return {}
}
